import { render, staticRenderFns } from "./EventFlowForm.vue?vue&type=template&id=3a12aa84&scoped=true"
import script from "./EventFlowForm.vue?vue&type=script&lang=ts"
export * from "./EventFlowForm.vue?vue&type=script&lang=ts"
import style0 from "./EventFlowForm.vue?vue&type=style&index=0&id=3a12aa84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a12aa84",
  null
  
)

export default component.exports